import type { SapSyncJob } from '../../domain/types'

export function formatJson(value: unknown): string {
  if (!value) return '-'
  try {
    return JSON.stringify(value, null, 2)
  } catch {
    return String(value)
  }
}

export function formatDuration(ms: number | null): string {
  if (ms == null) return '-'
  if (ms < 1000) return `${ms}ms`
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`
  return `${(ms / 60000).toFixed(1)}m`
}

export function buildCurlCommand(job: SapSyncJob): string {
  if (!job.url) return ''
  const parts: string[] = ['curl']
  if (job.httpMethod && job.httpMethod !== 'GET') {
    parts.push(`-X ${job.httpMethod}`)
  }
  parts.push(`'${job.url}'`)
  if (job.requestHeaders) {
    for (const [key, value] of Object.entries(job.requestHeaders)) {
      parts.push(`-H '${key}: ${value}'`)
    }
  }
  if (job.requestPayload && job.httpMethod !== 'GET') {
    const body = typeof job.requestPayload === 'string'
      ? job.requestPayload
      : JSON.stringify(job.requestPayload)
    parts.push(`-d '${body}'`)
  }
  return parts.join(' \\\n  ')
}
